/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './CoreProductDataServiceEntities.g';

// @ts-ignore
function aTPQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'ATP',
        'MFICLDeliveryScheduleParameters',
        DataServiceEntities.MFICLDeliveryScheduleParametersExtensionClass,
        key
    );
}

// // @ts-ignore
// function aTPQuery(id?: number): DataServiceQuery {
// const key = (id) ? { Id: id } :null;
// return new DataServiceQuery("ATP", "MFICLDeliveryScheduleParameters", DataServiceEntities.MFICLDeliveryScheduleParametersExtensionClass, key);
// }

export function createMFIATPInventoryDynamicInput(deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters): IDataServiceRequest {
    const query = aTPQuery();
    return query.createDataServiceRequestForOperation('MFIATPInventoryDynamic', true, DataServiceEntities.MFIATPInventoryDynamicResponseExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIATPInventoryDynamicResponse' }, { deliveryScheduleParam: deliveryScheduleParam });
}


export function mFIATPInventoryDynamicAsync(context: IContext, deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters): AsyncResult<DataServiceEntities.IMFIATPInventoryDynamicResponse> {
    const request = createMFIATPInventoryDynamicInput(deliveryScheduleParam);
    return callActionOrExecute<DataServiceEntities.IMFIATPInventoryDynamicResponse>(request, context.callerContext);
}

export function createMFIATPInventoryInput(deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters): IDataServiceRequest {
    const query = aTPQuery();
    return query.createDataServiceRequestForOperation(
        'MFIATPInventory',
        true,
        DataServiceEntities.MFIATPInventoryResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIATPInventoryResponse' },
        { deliveryScheduleParam: deliveryScheduleParam }
    );
}

export function mFIATPInventoryAsync(
    context: IContext,
    deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters
): AsyncResult<DataServiceEntities.IMFIATPInventoryResponse> {
    const request = createMFIATPInventoryInput(deliveryScheduleParam);
    return callActionOrExecute<DataServiceEntities.IMFIATPInventoryResponse>(request, context.callerContext);
}

export function createMFIATPInventoryStatusInput(
    deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters
): IDataServiceRequest {
    const query = aTPQuery();
    return query.createDataServiceRequestForOperation(
        'MFIATPInventoryStatus',
        true,
        DataServiceEntities.MFIATPInventoryStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIATPInventoryStatusResponse' },
        { deliveryScheduleParam: deliveryScheduleParam }
    );
}

export function mFIATPInventoryStatusAsync(
    context: IContext,
    deliveryScheduleParam: DataServiceEntities.IMFICLDeliveryScheduleParameters
): AsyncResult<DataServiceEntities.IMFIATPInventoryStatusResponse> {
    const request = createMFIATPInventoryStatusInput(deliveryScheduleParam);
    return callActionOrExecute<DataServiceEntities.IMFIATPInventoryStatusResponse>(request, context.callerContext);
}

// @ts-ignore
function bandMQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'BandM',
        'MFIDeliveryScheduleParameters',
        DataServiceEntities.MFIDeliveryScheduleParametersExtensionClass,
        key
    );
}

export function createMFIGetDSSlotsInput(deliveryScheduleParam: DataServiceEntities.IMFIDeliveryScheduleParameters): IDataServiceRequest {
    const query = bandMQuery();
    return query.createDataServiceRequestForOperation(
        'MFIGetDSSlots',
        true,
        DataServiceEntities.MFIATPDsSlotsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIATPDsSlotsResponse' },
        { deliveryScheduleParam: deliveryScheduleParam }
    );
}

export function mFIGetDSSlotsAsync(
    context: IContext,
    deliveryScheduleParam: DataServiceEntities.IMFIDeliveryScheduleParameters
): AsyncResult<DataServiceEntities.IMFIATPDsSlotsResponse> {
    const request = createMFIGetDSSlotsInput(deliveryScheduleParam);
    return callActionOrExecute<DataServiceEntities.IMFIATPDsSlotsResponse>(request, context.callerContext);
}

export function createMFIProductAvailabilityATPCacheInput(
    deliveryScheduleParam: DataServiceEntities.IMFIDeliveryScheduleParameters
): IDataServiceRequest {
    const query = bandMQuery();
    return query.createDataServiceRequestForOperation(
        'MFIProductAvailabilityATPCache',
        true,
        DataServiceEntities.MFIATPDsSlotsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIATPDsSlotsResponse' },
        { deliveryScheduleParam: deliveryScheduleParam }
    );
}

export function mFIProductAvailabilityATPCacheAsync(
    context: IContext,
    deliveryScheduleParam: DataServiceEntities.IMFIDeliveryScheduleParameters
): AsyncResult<DataServiceEntities.IMFIATPDsSlotsResponse> {
    const request = createMFIProductAvailabilityATPCacheInput(deliveryScheduleParam);
    return callActionOrExecute<DataServiceEntities.IMFIATPDsSlotsResponse>(request, context.callerContext);
}
